<template>
  <v-sheet
    class="mx-auto v-tags-list"
    ref="vLatestTips"
  >
    <v-slide-group
    :value="model"
      center-active
      show-arrows
    >
      <v-slide-item
        v-for="(tag, index) in tagListBox"
        :key="index"
        :data-index="index"
        v-slot="{ active, toggle }"
        @change="on_change_item(index, tagListBox)"
      >
        <v-btn
          class="mx-2"
          :input-value="active"
          active-class="white--text"
          :class="{'v-btn--active white--text': tag.fileId == $route.params.materialList ? true : false}"
          depressed
          rounded
          text outlined
          @click="toggle"
        >
          {{ tag.name }}
        </v-btn>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { get_api_data } from "@/utils/ajax";
export default {
  name: "v-tags-list",
  props: {
    tagListBox: Array
  },
  data: () => ({
    model: null,
    tagIdex: -1,
    tagLIst: "tagLIst",
  }),
  computed: {
    ...mapState("global", ["navInfos", "lv1_categoriesID"])
  },
  
  methods: {
    ...mapMutations("global", [
      // "updateDriveIdsID", 
      "updateLv1_categoriesID",
      "updateAllCardList",
      // "updateAllCardListMeta",
      ]),

     on_change_item(index, tagListBox) {
       this.updateAllCardList('')

      this.$router.push(`/${tagListBox[index].driveId}/${tagListBox[index].fileId}`);
      // this.updateDriveIdsID(tagListBox[index].driveId)
      this.updateLv1_categoriesID([tagListBox[index].fileId])

    }
  }
};
</script>
<style  lang="scss">
.v-tags-list {
  margin-bottom: 20px;
  width: 100%;
  .v-item-group {
    align-items: center;
    padding: 2px 4px;
  }
  .v-btn--active {
    background-color: $color-main;
  }
  .v-slide-group__next, .v-slide-group__prev {
    flex: 0 1 40px;
    width: 40px;
    min-width: 40px;
    height: 40px;
    border-radius: 50%;
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, .16);
    .v-icon.v-icon {
      font-size: 30px;
      color: #888888;
    }
    &.v-slide-group__prev--disabled,
    &.v-slide-group__next--disabled {
      .v-icon.v-icon {
        font-size: 30px;
        color: #dcdcdc !important;
      }
      
    }
  }
  
}
</style>
